import React from 'react';
import { Icon } from '.';

export const IconReview = props => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="18"
        viewBox="0 0 24 24"
      >
        <path
          fill="navy"
          stroke="none"
          d="
           M 19.61,4.59
           C 19.61,4.59 15.26,9.00 15.26,9.00
             15.26,9.00 18.52,9.00 18.52,9.00
             18.52,12.65 15.60,15.62 12.00,15.62
             10.90,15.62 9.86,15.34 8.96,14.85
             8.96,14.85 7.37,16.46 7.37,16.46
             8.71,17.32 10.29,17.82 12.00,17.82
             16.80,17.82 20.70,13.87 20.70,9.00
             20.70,9.00 23.96,9.00 23.96,9.00
             23.96,9.00 19.61,4.59 19.61,4.59
             19.61,4.59 19.61,4.59 19.61,4.59 Z
           M 5.48,9.00
           C 5.48,5.35 8.40,2.38 12.00,2.38
             13.10,2.38 14.14,2.66 15.04,3.15
             15.04,3.15 16.63,1.54 16.63,1.54
             15.29,0.68 13.71,0.18 12.00,0.18
             7.20,0.18 3.30,4.13 3.30,9.00
             3.30,9.00 0.04,9.00 0.04,9.00
             0.04,9.00 4.39,13.41 4.39,13.41
             4.39,13.41 8.74,9.00 8.74,9.00
             8.74,9.00 5.48,9.00 5.48,9.00
             5.48,9.00 5.48,9.00 5.48,9.00 Z"
        />
      </svg>
    </Icon>
  );
};
